export function createVariantStyleObserver(
  variantId: string,
  renderingId: string,
  setIsVisible: (value: boolean) => void,
) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as HTMLElement

            if (
              element.tagName === 'STYLE' &&
              element.classList.contains('static-variant-visible-style') &&
              element.dataset.variantId === variantId &&
              element.dataset.renderingId === renderingId
            ) {
              setIsVisible(true)
            }
          }
        })
      }
    })
  })

  // Observe changes to document.head where styles are injected
  observer.observe(document.head, {
    childList: true,
    subtree: false,
  })
  return observer
}
